<template>
  <div style="height: 80vh; justify-content: center; align-items: center; display: flex;">
    <div class="row" style="">
      <img alt="emplus logo" src="./assets/logo.svg" class="logo">

      <div class="hello">
        <h1> 홈페이지 리뉴얼 중입니다. </h1>

        <h3 style="line-height: 2;">
          보다 좋은 서비스를 제공하기 위해
          <strong style="color: #185798;">홈페이지 리뉴얼 중</strong>입니다. <br/>
          새로운 모습으로 다시 찾아뵙겠습니다. 감사합니다.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
@import "node_modules/sass-google-fonts/src/GoogleFonts.scss";
@include google-font('Gowun Batang');

#app {
  font-family: 'Gowun Batang', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.row {
  border: 1px solid rgba(208, 208, 208, 0.7);
  border-left: none;
  border-right: none;
  padding: 50px;
  width: 70%;

  .logo {
    opacity: 0.3;
    width: 450px;
  }
}



h1 {
  margin: 12px auto 5px;
}

h3 {
  margin-top: 10px;
  color: #77777a;
  font-weight: normal;
}

@media screen and (max-width: 600px) {
  h1 {
    font-size: 20px;
  }
  h3 {
    font-size: 14px;
  }
  .logo {
    width: 250px !important;
  }
}

</style>
